<template>
  <button @click="exportData" class="btn btn-info is-border-1 mr-1 mb-2">
    <i class="fa fa-download"></i>
    {{ $t('export') }}
    <b-modal v-model="exporting" :title="$t('exportingData')" @close="close" no-close-on-esc no-close-on-backdrop
             no-enforce-focus>
      <b-progress :max="totalCount">
        <b-progress-bar :value="downloadedCount"
                        :label="`${((downloadedCount / totalCount) * 100).toFixed(0)}%`"></b-progress-bar>
      </b-progress>
    </b-modal>
  </button>
</template>


<script>
import {saveAs} from 'file-saver';
import Excel from 'exceljs';
import moment from 'moment';

export default {
  props: ['filter', 'totalCount'],
  data() {
    return {
      exporting: false,
      cancelRequest: false,
      downloadedCount: 0
    }
  },
  methods: {
    exportData: async function () {
      this.downloadedCount = 0;
      this.exporting = true;
      let workbook = new Excel.Workbook();
      let sheet = workbook.addWorksheet('Webhook Vietguys');
      this.setupSheet(sheet);

      let response = null;
      let params = Object.assign({}, this.filter);
      params.page = 1;
      params.pageSize = 500;
      do {
        if (this.cancelRequest) {
          break;
        }
        let result = await this.$service.get('/vietguys-log', {
          params: params
        });
        params.page += 1;
        response = result.data;
        response.docs.forEach(item => {
          let row = {
            client: item.client ? item.client.domain : '',
            messageCampaign: item.messageCampaign ? item.messageCampaign.name : '',
            brandName: item.brandName ? item.brandName.name : '',
            gateway: item.gateway ? item.gateway.name : '',
            template: item.template ? item.template.name : '',
            messageCampaignContact: item.messageCampaignContact ? item.messageCampaignContact.name : '',
            number: item.number,
            telco: item.telco ? item.telco : '',
            content: item.sms && item.sms.content ? item.sms.content : '',
            type: this.$t(item.type),
            body: item.body ? item.body : '',
            status: item.status === 'fail' ? this.$t('error') : this.$t('success'),
            createTime: moment(item.createTime).format('DD/MM/YYYY HH:mm:ss'),
            sendTime: item.sendTime ? moment(item.sendTime).format('DD/MM/YYYY HH:mm:ss') : '',
          }
          sheet.addRow(row);
          this.downloadedCount += 1;
        });
      } while (response && response.hasNextPage);

      workbook.xlsx.writeBuffer({base64: true}).then(data => {
        this.exporting = false;
        saveAs(new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
            'webhook-vietguys.xlsx');
      }).finally(() => {
        this.cancelRequest = false;
        this.downloadedCount = 0;
      });
    },
    setupSheet: function (sheet) {
      sheet.columns = [
        {header: this.$t('client'), key: 'client', width: 25},
        {header: this.$t('campaign'), key: 'messageCampaign', width: 25},
        {header: 'Brand name', key: 'brandName', width: 25},
        {header: 'Gateway', key: 'gateway', width: 25},
        {header: this.$t('messageTemplate'), key: 'template', width: 25},
        {header: this.$t('contactName'), key: 'messageCampaignContact', width: 25},
        {header: this.$t('toNumber'), key: 'number', width: 25},
        {header: this.$t('network'), key: 'telco', width: 25},
        {header: this.$t('content'), key: 'content', width: 25},
        {header: this.$t('type'), key: 'type', width: 25},
        {header: 'Request body', key: 'body', width: 25},
        {header: this.$t('status'), key: 'status', width: 25},
        {header: this.$t('createTime'), key: 'createTime', width: 25},
        {header: this.$t('sendTime'), key: 'sendTime', width: 25},
      ];
    },
    close() {
      this.cancelRequest = true;
    }
  },
  i18n: {
    messages: {
      en: {
        content: 'Content',
        createTime: 'Create time',
        sendTime: 'Send time',
        care: 'Care',
        ads: 'Ads',
        type: 'Type',
        toNumber: 'Send to number',
        campaign: 'Campaign',
        messageTemplate: 'Message template',
        contactName: 'Send to contact name',
        network: 'Contact\'s network is sent to',
      },
      vi: {
        content: 'Nội dung',
        createTime: 'Tạo lúc',
        sendTime: 'Gửi lúc',
        care: 'CSKH',
        ads: 'Quảng cáo',
        type: 'Loại',
        toNumber: 'Gửi tới số điện thoại',
        campaign: 'Chiến dịch',
        messageTemplate: 'Mẫu tin nhắn',
        contactName: 'Gửi tới tên liên hệ',
        network: 'Nhà mạng của liên hệ gửi tới',
      }
    }
  }
}
</script>